import { CapoPlugin } from "/usr/src/app/node_modules/.pnpm/@unhead+vue@1.11.14_vue@3.5.13_typescript@5.1.6_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];